import { Component, ReactNode, createRef } from 'react';

import { BraxModals } from '../BraxModals';
import { BraxToasts } from '../BraxToasts';
import { BraxAsides } from '../BraxAsides';

export class BraxProviders extends Component<{ children: ReactNode }> {

    ref = createRef<HTMLDivElement>();

    render() {
        return (
            <BraxToasts>
                <BraxModals>
                    <BraxAsides>
                        { this.props.children }
                    </BraxAsides>
                </BraxModals>
            </BraxToasts>
        );
    }

}
